import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorHandler } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Respuesta, Usuario } from '../models';

@Injectable({
  providedIn: 'root'
})
export class RolesService {
   
  url = environment.api;

  constructor(private http: HttpClient, private errorHandler: ErrorHandler) {}

  obtenerListaUsuarios() {
    return this.http.get(`${this.url}Usuarios`).pipe(
      map((response: Respuesta) => response)
    );
  }

  insertarUsuario( form : Usuario) {
    form["usuarioAsignadorId"] = 1;
    return this.http.post(`${this.url}Usuarios`, form).pipe(
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError('Error al insertar usuario');
      })
    );
  }

  actualizarUsuario( form : Usuario) {
    form["usuarioAsignadorId"] = 1;
    return this.http.put(`${this.url}Usuarios`, form).pipe(
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError('Error al actualizar usuario');
      })
    );
  }

  eliminarUsuario( id : number) {
    return this.http.delete(`${this.url}Usuarios/${id}`).pipe(
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError('Error al eliminar usuario');
      })
    );
  }

  obtenerRoles() {
    return this.http.get(`${this.url}Usuarios/roles`).pipe(
      map((response: Respuesta) => response)
    );
  }

  obtenerSociedades() {
    return this.http.get(`${this.url}Usuarios/sociedades`).pipe(
      map((response: Respuesta) => response)
    );
  }

}
